import { Base } from "../../framework/base";
import { IInstantMessageChannelInvitation, InstantMessageChannelInvitation } from "./instantMessageChannelInvitation";
import { IInstantMessageListItem, InstantMessageListItem } from "./instantMessageListItem";

export interface IInstantMessageChannelItemData {
    id: string;
    code: string;
    picture: string;
    comment: string;
    active: boolean;
    rowId: string;
    userIsAdmin: boolean;
    userIsOnlyAdmin: boolean;
    isGroup: boolean;
    otherUserCode: string;
    hasUnreadMessages: boolean;
    latestMessage: IInstantMessageListItem;
    invitation: IInstantMessageChannelInvitation;
}

export interface IInstantMessageChannelItem extends IInstantMessageChannelItemData {
    getHash(): string;
    getPicture(): string;
    getPictureClass(): string;
    getLatestMessageDate(): number;
}

export class InstantMessageChannelItem implements IInstantMessageChannelItem {
    id: string;
    code: string;
    picture: string;
    comment: string;
    active: boolean;
    rowId: string;
    userIsAdmin: boolean;
    userIsOnlyAdmin: boolean;
    isGroup: boolean;
    otherUserCode: string;
    hasUnreadMessages: boolean;
    latestMessage: InstantMessageListItem;
    invitation: InstantMessageChannelInvitation;

    constructor();
    constructor(obj: IInstantMessageChannelItem);
    constructor(obj: IInstantMessageChannelItemData);
    constructor(obj?: any) {
        this.id = obj && obj.id || "";
        this.code = obj && obj.code || "";
        this.picture = obj && obj.picture || "";
        this.comment = obj && obj.comment || "";
        this.active = obj && obj.active || false;
        this.rowId = obj && obj.rowId || "";
        this.userIsAdmin = obj && obj.userIsAdmin || false;
        this.userIsOnlyAdmin = obj && obj.userIsOnlyAdmin || false;
        this.isGroup = obj && obj.isGroup || false;
        this.otherUserCode = obj && obj.otherUserCode || "";
        this.hasUnreadMessages = obj && obj.hasUnreadMessages || false;
        this.latestMessage = obj?.latestMessage ? new InstantMessageListItem(obj.latestMessage) : null;
        this.invitation = obj?.invitation ? new InstantMessageChannelInvitation(obj.invitation) : null;
    }

    getHash(): string {
        return this.id + "#" + this.rowId + "#" + (this.latestMessage ? this.latestMessage.getHash() : "") + "#" + (this.invitation ? this.invitation.getHash() : "") + "#" + (this.hasUnreadMessages ? "1" : "0");
    }

    getPicture(): string {
        if (this.picture) {
            return this.picture;
        }
        return "";
    };

    getPictureClass(): string {
        if (this.getPicture()) {
            return "";
        } else {
            return this.isGroup ? "icon instantMessageGroup" : "";
        }
    };

    getLatestMessageDate(): number {
        if (this.invitation) {
            return this.invitation.sender.date;
        }
        if (this.latestMessage) {
            return this.latestMessage.modifyUser.date;
        }
        return 0;
    }

    static getHash(items: IInstantMessageChannelItem[]): string {
        if (!items && items.length < 1) return "";
        return items.map(i => i.getHash()).join(",");
    }

    static sortInstantMessageListItems(items: IInstantMessageChannelItem[]): IInstantMessageChannelItem[] {
        if (!items && items.length < 2) return items;
        return items.sort((a: IInstantMessageChannelItem, b: IInstantMessageChannelItem) => {
            if (!a || !b) return 0;
            let result = Base.numCompare(a.active ? 0 : 1, b.active ? 0 : 1);
            if (result !== 0) return result;
            result = -1 * Base.numCompare(a.getLatestMessageDate(), b.getLatestMessageDate());
            if (result !== 0) return result;
            return Base.strCompare(a.code, b.code);
        });
    }
}